export class Smoothlinks {
    static findAndProcessLinks() {
        document.querySelectorAll('[data-smooth-links]:not([data-smooth-links-inited]) a')
            .forEach((anchor) => {
                const href = anchor.getAttribute('href');

                if (href.includes('#')) {
                    anchor.addEventListener('click', function (e) {
                        e.preventDefault();

                        let hrefSplited = href.split('#');
                        const scrollTarget = document.getElementById(hrefSplited[1]);
                        const elementPosition = scrollTarget.getBoundingClientRect().top;
                        const offsetPosition = elementPosition - 70;

                        window.scrollBy({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    });
                }
            });
    }
}

if (window.BX) {
    window.BX.ready(() => {
        Smoothlinks.findAndProcessLinks();
    });
} else {
    console.error('Не удалось запустить обработчик, не найден BX');
}